export const config: typeof window.__CONFIG__ = {
  SERVICE_NAME: window.__CONFIG__.SERVICE_NAME,
  ENV_NAME: window.__CONFIG__.ENV_NAME,
  API_BASE_URL: window.__CONFIG__.API_BASE_URL,
  THEME: window.__CONFIG__.THEME,
  KENTUCKY_API_BASE_URL: window.__CONFIG__.KENTUCKY_API_BASE_URL,
  GOOGLE_MAP_API_KEY: window.__CONFIG__.GOOGLE_MAP_API_KEY,
  AWS_REGION: window.__CONFIG__.AWS_REGION || "us-east-1",
  TRANSFER_FLAVOR: window.__CONFIG__.TRANSFER_FLAVOR || "A",
  THEME_MODE: window.__CONFIG__.THEME_MODE || "",
  POSTHOG_KEY: window.__CONFIG__.POSTHOG_KEY,
  POSTHOG_HOST: window.__CONFIG__.POSTHOG_HOST,
  SEON_DEVICE_ENABLED: window.__CONFIG__.SEON_DEVICE_ENABLED,
  SEON_DEVICE_MOCK: window.__CONFIG__.SEON_DEVICE_MOCK,
  SEON_AGENT_URL: window.__CONFIG__.SEON_AGENT_URL,
  SEON_DEVICE_TIMEOUT_MS: window.__CONFIG__.SEON_DEVICE_TIMEOUT_MS,
  NOVU_APPLICATION_IDENTIFIER: window.__CONFIG__.NOVU_APPLICATION_IDENTIFIER,
};
